module.exports = require("./ms-Arab.js");